import {
  AutoOrderRequest,
  AutoOrderRequestToJSON,
  BibliographySetAutoOrderInfoUpdateRequest,
  BibliographySetAutoOrderInfoUpdateRequestToJSON,
  BibliographySetCreateRequest,
  BibliographySetCreateRequestToJSON,
  BibliographySetDetail,
  BibliographySetDetailFromJSON,
  BibliographySetManagementInfoUpdateRequest,
  BibliographySetManagementInfoUpdateRequestToJSON,
  BibliographySetUpdateRequest,
  BibliographySetUpdateRequestToJSON,
  HTTPBody
} from '@/api'
import * as runtime from '../runtime'

export class BibliographySetApi extends runtime.BaseAPI {
  async getBibliography(id: number): Promise<BibliographySetDetail> {
    const response = await this.requestGet(`/bibliographies-set/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographySetDetailFromJSON(jsonValue)
    ).value()
  }

  async createBibliographySet(
    request: BibliographySetCreateRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = BibliographySetCreateRequestToJSON(request)
    const response = await this.requestPost(
      '/bibliographies-set',
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.bibliography_id
    ).value()
  }

  async updateBibliographySet(
    bibliographyId: number,
    request: BibliographySetUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = BibliographySetUpdateRequestToJSON(request)
    const response = await this.requestPut(
      `/bibliographies-set/${bibliographyId}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteBibliographySet(
    bibliographyId: number
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(
      `/bibliographies-set/${bibliographyId}`
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateBibliographySetManagementInfo(
    request: BibliographySetManagementInfoUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = BibliographySetManagementInfoUpdateRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/bibliographies-set/${request.id}/management-info`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async autoOrder(request: AutoOrderRequest): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = AutoOrderRequestToJSON(request)
    const response = await this.requestPost(
      `/bibliographies-set/${bodyParameters.id}/auto-order`
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateAutoOrderInfo(
    request: BibliographySetAutoOrderInfoUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = BibliographySetAutoOrderInfoUpdateRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/bibliographies-set/${bodyParameters.id}/auto-order-info`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
